import {AbstractModel} from '../abstract-model';
import {StaticPage} from './static-page';
import {Document} from '../document';

export class StaticPageImage extends AbstractModel {
  id: number | null = null;
  staticPage: StaticPage | null = null;
  document!: Document;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.staticPage) {
      this.staticPage = new StaticPage().deserialize(input.staticPage);
    }

    if (input.document) {
      this.document = new Document().deserialize(input.document);
    }

    return this;
  }

  isVideo(): boolean {
    return this.document.type?.includes('video') ?? false;
  }
  isCss(): boolean {
    return this.document.filename?.endsWith('.css') ?? false;
  }

  isJs(): boolean {
    return this.document.filename?.endsWith('.js') ?? false;
  }
}
